'use strict';

var util = require('../util/property-util');
var nocUtil = require('../util/noc-util');


var data = new Map();
var conversions = new Map();
var mapping = new Map();

conversions.set("B1", "2100 MHz");
conversions.set("B2", "1900 PCS MHz");
conversions.set("B3", "1800 MHz");
conversions.set("B4", "1700/2100 MHz");
conversions.set("B5", "850 MHz");
conversions.set("B7", "2600 MHz");
conversions.set("B8", "900 MHz");
conversions.set("B9", "1800 MHz");
conversions.set("B11", "1500 MHz Lower");
conversions.set("B12", "700 MHz ac");
conversions.set("B13", "700 MHz c");
conversions.set("B17", "700 MHz bc");
conversions.set("B18", "800 MHz Lower");
conversions.set("B19", "800 MHz Upper");
conversions.set("B20", "800 MHz DD");
conversions.set("B21", "1500 MHz Upper");
conversions.set("B25", "1900+ MHz");
conversions.set("B26", "850 + MHz");
conversions.set("B28", "700 MHz APT");
conversions.set("B30", "2300 MHz WCS");
conversions.set("B38", "TD 2600 MHz");
conversions.set("B39", "TD 1900 + MHz");
conversions.set("B40", "TD 2300 MHz");
conversions.set("B41", "TD 2500 MHz");
conversions.set(null, "Unknown");

function MessageDescriptorConvertFactory(){

}

MessageDescriptorConvertFactory.prototype.getKeyForObjectName = function (objectName) {
    var value = mapping.get(objectName);
    if (util.isDefined(value)) {
        return value;
    } else {
        return null;
    }
};

MessageDescriptorConvertFactory.prototype.convertStringToIndex = function (fieldName, value, objectName, useExactValue) {
    if (!util.isDefined(value)) {
        return null;
    }
    if (util.isDefined(objectName)) {
        mapping.set(objectName, fieldName);
    }
    if (!useExactValue) {
        value = value.trim();
        value = nocUtil.formatStringForDisplay(value);
    }

    var fieldArray = data.get(fieldName);
    if (!util.isDefined(fieldArray)) {
        data.set(fieldName, []);
        fieldArray = data.get(fieldName);
    }
    var index = fieldArray.indexOf(value);
    if (index == -1) {
        fieldArray.push(value);
        index = fieldArray.indexOf(value);
    }
    return index + 1;
};

MessageDescriptorConvertFactory.prototype.convertIndexToString = function (fieldName, index) {
    function isFloat(n) {
        return n != "" && !isNaN(n) && Math.round(n) != n;
    }

    if (isFloat(index)) {
        return "Undecided"
    } else if (index == 0 || !util.isDefined(fieldName) || !util.isDefined(data.get(fieldName)) || !util.isDefined(data.get(fieldName)[index - 1])) {
        return "Undefined";
    }

    var value = data.get(fieldName)[index - 1];
    var convertedValue = conversions.get(value);

    var returnValue = value;
    if (util.isDefined(convertedValue)) {
        returnValue = convertedValue;
    }
    return returnValue;
};

module.exports = MessageDescriptorConvertFactory;